'use client';

import Link from 'next/link';
import { FileQuestion, Home, ArrowLeft, RefreshCw } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white border border-slate-200/80 rounded-3xl p-8 text-center shadow-xl shadow-slate-100 relative overflow-hidden">
        
        {/* Fondo decorativo sutil */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-blue-50 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-indigo-50 rounded-full blur-3xl pointer-events-none"></div>

        {/* Icono animado o principal */}
        <div className="relative inline-flex p-4 bg-blue-50 text-blue-600 rounded-2xl mb-6 shadow-inner">
          <FileQuestion className="w-10 h-10 animate-bounce" />
        </div>

        {/* Código de error y título */}
        <div className="space-y-2 mb-6">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
            Error 404
          </span>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
            Página no encontrada
          </h1>
          <p className="text-xs text-slate-500 leading-relaxed max-w-xs mx-auto">
            La ruta que buscas no existe, fue movida o el enlace es incorrecto. Pero no te preocupes, estás a un clic de volver a la ruta segura.
          </p>
        </div>

        {/* Botones de acción */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2.5">
          <button
            onClick={() => window.history.back()}
            className="w-full sm:w-auto px-4 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-semibold transition-colors flex items-center justify-center gap-2 cursor-pointer"
          >
            <ArrowLeft className="w-4 h-4" />
            Regresar
          </button>
          
          <Link
            href="/"
            className="w-full sm:w-auto px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-xs font-semibold transition-colors flex items-center justify-center gap-2 shadow-sm shadow-blue-500/20 cursor-pointer"
          >
            <Home className="w-4 h-4" />
            Ir al Inicio
          </Link>
        </div>

        {/* Pie de página sutil del componente */}
        <div className="mt-8 pt-6 border-t border-slate-100 text-[11px] text-slate-400">
          Sistema de Gestión DC-3 • Módulo de Navegación
        </div>

      </div>
    </div>
  );
}